import { useState } from 'react';
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';

interface RejectLeadDialogProps {
  open: boolean;
  errorMessage: string | null;
  onClose: () => void;
  onSubmit: (reason: string) => Promise<void>;
}

/** Rejection always requires a reason — no silent rejection (Approval
 * workflow, section 12). */
export const RejectLeadDialog = ({ open, errorMessage, onClose, onSubmit }: RejectLeadDialogProps) => {
  const [reason, setReason] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!reason.trim()) return;
    setSubmitting(true);
    try {
      await onSubmit(reason.trim());
      setReason('');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Reject lead</DialogTitle>
      <DialogContent>
        {errorMessage && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {errorMessage}
          </Alert>
        )}
        <TextField
          label="Rejection reason"
          required
          fullWidth
          multiline
          minRows={2}
          autoFocus
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          helperText="The counselor will see this reason."
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" color="error" disabled={!reason.trim() || submitting} onClick={handleSubmit}>
          {submitting ? 'Rejecting…' : 'Reject'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
